export default "__VITE_ASSET__B51pGHx___"